import React, { ReactElement } from 'react';
import { injectIntl } from 'react-intl';
import { Card } from 'antd';

import Page from '../../../shared/components/layout/Page.layout';
import { Text } from '../../../shared/components';
import TablePedidoslcList from '../../containers/tablePedidoslcList';

function PedidoslcList({ intl }) {
  const pedidosTable = (
    <TablePedidoslcList />
  );
  const inIframe = window.top != window.self;
  return (
    <Page
      overrideMaxWidth={inIframe ? '100%' : undefined}
      tituloTraduccionId={inIframe ? null : 'navegacion.pedidos.pedidos_lc'}
      navigationItems={inIframe ? null : [
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.home" />,
          link: '',
        },
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pedidos" />,
          link: '/pedidos/pedidoslc',
        },
      ]}
    >
      <style>{'.custom-no-margin-card .ant-card-body{padding:0;}'}</style>
      <Card
        className="custom-no-margin-card"
        title={null}
      >
        <div className="pedido pedido-list">
          {pedidosTable}
        </div>
      </Card>
    </Page>
  );
}

export default injectIntl(PedidoslcList);
